
    import { mapGetters, mapMutations, mapActions } from "vuex"
    import { capitalize } from "lodash"
    import { IPrompt } from "@/types"
    import { defineComponent, PropType } from "vue"
    import InputTextarea from "@/components/misc/InputTextarea.vue"
    import Accordeon from "@/components/misc/Accordeon.vue"
    import InputText from "@/components/misc/InputText.vue"
    import { gptQuery, gptQueryRunPrompt } from "../Playground.vue"
    import { Getters } from "@/store/getters"
    import Result from "./Result.vue"
    import ls from "local-storage"
    import InputSwitch from "@/components/misc/InputSwitch.vue"
    import { toast } from "vue3-toastify"
    import KeyWarning from "@/components/misc/KeyWarning.vue"
    import RunButton from "@/components/misc/RunButton.vue"
    import { copyToClipboard } from "@/helpers"
    import LogIn from "@/components/auth/LogIn.vue"
    import GPTSettings, { defaultGPTSettings } from "../misc/GPTSettings.vue"
    import { CreateCompletionRequest } from "openai"

    export interface IVariable{
        name: string
        inputType?: string
    }

    export default defineComponent({
        props: {
            prompt: Object as PropType<IPrompt>,
            isNew: Boolean,
        },
        components: {
            LogIn,
            RunButton,
            InputSwitch,
            Result,
            InputText,
            Accordeon,
            InputTextarea,
            GPTSettings
        },
        // emits: ['update:modelValue'], this.$emit('update:modelValue', title)
        data() {
            return {
                gptSettings: ls("gptSettings." + this.prompt?.id) as any || ls("gptSettings") || defaultGPTSettings as Partial<CreateCompletionRequest>,
                showSettings: false,
                accordeonValue: false,
                showKeyDescription: false,
                isInFav: false,
                capitalize,
                isLoading: false,
                result: "",
                showContent: false,
                varValues: {} as {[key: string]: string},
            }
        },
        computed: {
            link(): string {
                return location.origin + "/prompt/" + this.prompt?.id
            },

            canEdit(): boolean {
                return this.isModer || this.prompt?.userId === this.user?.userId || this.isNew
            },
            canDelete(): boolean {
                return (this.isAdmin || this.prompt?.userId === this.user?.userId) && !this.isNew
            },

            ...mapGetters(["categories", "isModer", "user", "isAdmin", "guest"]),

            variables(): IVariable[] {
                const matches = [...(this.prompt?.content || "").matchAll(/\$(\w+)(:\w+)?/g)]
                return matches?.map((match) => ({ name: match[1], inputType: match[2]?.slice(1) }))
            },
            getters(): Getters {
                return this.$store.getters
            },
            settingsIsNotDefault(): boolean {
                if ((ls as any)("gptSettings")) {
                    return JSON.stringify(this.gptSettings) !== JSON.stringify((ls as any)("gptSettings"))
                } else {
                    return JSON.stringify(this.gptSettings) !== JSON.stringify(defaultGPTSettings)
                }
            },
        },
        methods: {
            ...mapActions(["sendOpenedPrompt", "sendRunnedPrompt", "runPrompt", "getUser"]),
            updateGPTSettings(value: Partial<CreateCompletionRequest>) {
                ls("gptSettings." + this.prompt?.id, value)
                this.gptSettings = value
            },
            sendOpened() {
                (+(this.prompt?.id || -1) !== -1) && this.sendOpenedPrompt(this.prompt?.id)
            },
            sendRunned() {
                this.sendRunnedPrompt(this.prompt?.id)
            },

            ...mapMutations(["DEL_FAVORITE", "ADD_FAVORITE"]),
            copyToChatGPT() {
                this.copy(this.prompt?.content || "")
                setTimeout(() => {
                    window.open("https://chat.openai.com/chat")
                }, 0)
            },

            copyLink() {
                this.copy(this.link)
            },

            updateFav() {
                this.isInFav = (ls as any)("my")?.includes(this.prompt?.id)
            },

            toggleFav() {
                let newValue
                if (this.isInFav) {
                    newValue = (ls as any)("my").filter((myOne: string) => myOne !== this.prompt?.id)
                    this.DEL_FAVORITE(this.prompt?.id)
                } else {
                    newValue = [...((ls as any)("my") || []), this.prompt?.id]
                    this.ADD_FAVORITE(this.prompt)
                }
                (ls as any)("my", newValue)
                this.updateFav()
            },

            copy(content: string) {
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(content || "")
                        .then(() => {
                            console.log("Text copied to clipboard")
                            toast("The link copied in to clipboard", { position: "bottom-right", theme: "colored" })
                        })
                        .catch((error) => {
                            console.error("Error copying text: ", error)
                        })
                } else {
                    copyToClipboard(content || "")
                }
            },

            async run() {
                if ((ls as any)("mode") !== "client") {
                    const varValues = Object.entries(this.varValues).map(([key, value]) => ({ field: key, value }))
                    this.result = (await gptQueryRunPrompt(this.prompt?.id || "", varValues, this, this.gptSettings))?.trim() || ""
                    this.showKeyDescription = false
                    this.sendRunned()
                } else {
                    if ((ls as any)("apiKey")) {
                        let prompt = (this.prompt?.content || "")
                        this.variables.forEach((variable) => {
                            prompt = prompt.replaceAll("$" + variable.name + (variable.inputType ? ":" + variable.inputType : ""), this.varValues[variable.name] || "")
                        })
                        this.result = await gptQuery(prompt, this, this.gptSettings) || ""
                        this.showKeyDescription = false
                        this.sendRunned()
                    } else {
                        this.showKeyDescription = true
                    }
                }
            },

        },

        watch: {
            variables: {
                handler (newVal: IVariable[]) {
                    this.varValues = { ...this.varValues, ...Object.fromEntries(newVal?.map((newValOne) => [newValOne.name, ""])) }
                },
                immediate: true
            },

        },

        created () {
            if (this.isNew) {
                this.showContent = true
            }
            this.updateFav()
        },
    })

    